import { ReactNode, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

type Props = {
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Title shown both on the help button tooltip and the modal header. */
  helpTitle: string;
  /** Body of the help modal — pass the explanatory copy as children. */
  children: ReactNode;
  placeholder?: string;
  onKeyDown?: (e: React.KeyboardEvent) => void;
};

/**
 * A text input paired with a "?" button that opens a help modal. The modal's
 * body content is provided by the caller as children, so each usage can
 * document its own expression syntax without duplicating the input/modal shell.
 *
 * Renders only the input row and modal — wrap in a Form.Group with a
 * Form.Label at the call site.
 */
const EditStringWithHelp = ({ name, value, onChange, helpTitle, children, placeholder, onKeyDown }: Props) => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <Form.Control type="text" name={name} value={value} placeholder={placeholder} onChange={onChange} onKeyDown={onKeyDown} />
        <Button type="button" variant="outline-secondary" onClick={() => setShowHelp(true)} aria-label={helpTitle} title={helpTitle}>
          ?
        </Button>
      </div>
      <Modal show={showHelp} onHide={() => setShowHelp(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{helpTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setShowHelp(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditStringWithHelp;
